import { useEffect } from 'react';


export default function useExternalScripts(fileName, once=true) {

    useEffect(() => {

        const script = document.createElement('script');

        script.src = "/app/js/" + fileName;
        if (!once) {
            let old = document.querySelectorAll("script[src='/app/js/" + fileName + "']");
            old.forEach((o) => o.remove());
        }
        if (document.querySelectorAll("script[src='/app/js/" + fileName + "']").length === 0)
            document.body.appendChild(script);


    }, [fileName]);
};